import { render, staticRenderFns } from "./ItemsWithoutManageAccess.vue?vue&type=template&id=6b8f97da"
import script from "./ItemsWithoutManageAccess.vue?vue&type=script&lang=js"
export * from "./ItemsWithoutManageAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports